import { Reducer } from 'redux';
import { TrackingState, TrackingTypes } from './types';

const INITIAL_STATE: TrackingState = {
  data: [],
  loading: false,
  error: false,
  filter: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<TrackingState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TrackingTypes.LOAD_TRACKING_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case TrackingTypes.LOAD_TRACKING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case TrackingTypes.LOAD_TRACKING_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case TrackingTypes.FILTER_TRACKING:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case TrackingTypes.CLEAR_TRACKING:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default reducer;
